import * as React from 'react'
import { Link } from 'react-router-dom'
import { debounce } from 'throttle-debounce'
import TableDrivers from '../../containers/drivers/TableDrivers'
import UIMessages from '../../utils/ui-messages'
import FindIcon from '../icons/ui/Find'
import HorizontalSelector from '../HorizontalSelector'
import HorizontalSelectorItem from '../HorizontalSelectorItem'
import { IDriverFilters } from '../../types'
import { Button, Input } from '@mobiscroll/react-latest'
import history from 'src/history'

interface IDriversTablePaneProps {
  currentOrgId: string
  updateDriverFilters: (item: IDriverFilters) => Promise<any>
}

interface IDriversTablePaneState {
  filters: IDriverFilters
  searchValue: string
}

class DriversTablePane extends React.Component<IDriversTablePaneProps, IDriversTablePaneState> {
  public state: IDriversTablePaneState = {
    filters: {
      isArchived: false,
      search: '',
      organizationId: this.props.currentOrgId
    },
    searchValue: ''
  }

  public searchDriversDebounced = debounce(500, (search: string) => {
    this.setState({ filters: { ...this.state.filters, search } })
    this.props.updateDriverFilters({ ...this.state.filters, search })
  })

  public componentDidUpdate(prevProps: IDriversTablePaneProps) {
    if (this.props.currentOrgId !== prevProps.currentOrgId) {
      this.setState({ filters: { ...this.state.filters, organizationId: this.props.currentOrgId } })
    }
  }

  public render() {
    const { filters } = this.state

    const ROUTES = {
      CREATE_DRIVER: '/drivers/create'
    } as const

    const createDriver = () => {
      history.push(ROUTES.CREATE_DRIVER)
    }
    return (
      <div className='pt3'>
        <div className='flex mb2 items-center'>
          <div className='ml2'>
            <HorizontalSelector>
              <HorizontalSelectorItem isSelected={!filters.isArchived}>
                <div className='uppercase cursor--pointer' onClick={this.setArchived(false)}>
                  {UIMessages.common.driversList}
                </div>
              </HorizontalSelectorItem>
              <HorizontalSelectorItem isSelected={filters.isArchived}>
                <div className='uppercase cursor--pointer' onClick={this.setArchived(true)}>
                  {UIMessages.common.archivedDrivers}
                </div>
              </HorizontalSelectorItem>
            </HorizontalSelector>
          </div>
          <div style={{ flex: 1 }}>&nbsp;</div>
          <div className='flex items-center mr3'>
            <Input
              className='DriversSearchInput mr1 mobiscroll-input'
              type='text'
              onChange={this.searchDrivers}
              value={this.state.searchValue}
              placeholder={UIMessages.common.search}
              theme='ios'
              themeVariant='light'
              inputStyle='box'
              labelStyle='floating'
            />
            <FindIcon className='svg-stroke-grey3' />
          </div>
          <Button className='mobiscroll-green-btn' onClick={createDriver}>
            <span className='font-white'>+ {UIMessages.common.createNewDriver}</span>
          </Button>
        </div>
        <div>
          <TableDrivers />
        </div>
      </div>
    )
  }

  private searchDrivers = (e: any) => {
    const regex = /[\\\/\$\|\&\%\#\.\?]/g
    const search = e && e.target.value ? e.target.value.replaceAll(regex, '') : undefined
    this.setState({ searchValue: search })
    this.searchDriversDebounced(search)
  }

  private setArchived = (isArchived: boolean) => {
    return (e: any) => {
      this.setState({ filters: { ...this.state.filters, isArchived } })
      this.props.updateDriverFilters({ ...this.state.filters, isArchived })
    }
  }
}

export default DriversTablePane



// WEBPACK FOOTER //
// ./src/components/drivers/TableDriversPane.tsx